import clsx from 'clsx';
import styles from './TankMark.module.css';

/**
 * Tank Redesign TankMark — phosphor wordmark for the left rail / nav.
 *
 * Source: ~/Downloads/tank-redesign/tokens.jsx → `TankMark` function.
 * Renders a pill-bordered "Tank" wordmark, optionally followed by a
 * subtitle ("desk · editor"). Used in OperatorLayout's rail header.
 *
 * @param {Object} props
 * @param {boolean} [props.sub=true] - render the "desk · editor" subtitle
 * @param {string} [props.className]
 */
export default function TankMark({ sub = true, className, ...rest }) {
  return (
    <div className={clsx(styles.wrap, className)} {...rest}>
      <div className={styles.mark}>Tank</div>
      {sub && <span className={styles.sub}>desk · editor</span>}
    </div>
  );
}
